import BookItem from "../common/bookItem";
//報廢中
export default class MapToggleChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.isUsed = false;
        this.openAns = false;
        this.connectNumber = this.el.connectNumber;

        this.target.visible = false;
    }
}